<template>
    <div class="course_center">
        <div class="course_main">
            <div class="header">
                <p class="title">课程列表</p><span class="tip" style="padding-left: 24px;"
                    @click="getCourseList">师者，所以传道受业解惑也</span>

            </div>
            <div class="main" v-if="CourserList.length>0">
                <div class="class" v-for="(item, index) in CourserList" @click="goClass(item)">
                    <img class="class_img" :src="item.course_cover" alt="">
                    <p class="class_name">{{ item.course_name }}</p>
                    <p class="class_class">课程分类: <span>{{ item.resource_class_name }}</span></p>
                </div>


            </div>
           <div class="footer" v-if="CourserList.length>0">
                <el-pagination background @current-change="handleCurrentChange" :current-page.sync="course.page"
                    :page-size="course.limit" layout="prev, pager, next" :total="total">
                </el-pagination>
           </div>
           <div class="noData" v-else>
            <img src="../../assets/teacherPeitaoCl/supportingInformationNoData.png" alt="">
            <div>暂无数据</div>

           </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            CourserList: [],
            course: {
                paging: 1,
                page: 1,
                limit: 12,
            },
            total: 0
        }
    },
    methods: {
        getCourseList() {
            let param = {
                paging: this.course.paging,
                page: this.course.page,
                limit: this.course.limit,
            }
            this.$shttp.axiosGetBy(this.$api.admin_showTeaCourse, param, (res) => {
                if (res.code == 200) {
                    this.CourserList = res.data.course_list.length > 0 ? res.data.course_list : []
                    this.total=res.data.total
                }
            }, (err) => {
                console.log(err)
            });

        },
        goClass(item) {
            this.$router.push({ path: "/qualityCourse/teacher/index", query: { course_id: item.course_id } })
        },
        handleCurrentChange(val){
            this.course.page=val
            this.getCourseList()
        }
    },
    mounted() {
        this.getCourseList()
    }
}


</script>
<style lang="scss" scoped>
.course_center {
    width: 100%;
    height: 100%;
    display: flex;
    //   align-items: center;
    justify-content: center;
    background-color: #FFFFFF;

    .course_main {
        width: 1200px;
        // background-color: #FFFFFF;

        .header {
            display: flex;
            align-items: center;

            .title {

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 32px;
                color: #3C3C3C;
                line-height: 38px;
                text-align: left;
                font-style: normal;
                text-transform: none;


            }
        }

        .main {
            display: flex;
            flex-wrap: wrap;
            // background-color: pink;
            box-sizing: border-box;
            gap: 0 24px;

            .class {
                width: 282px;
                margin-bottom: 30px;

                // height: 200px;
                // margin-right: 20px;
                .class_img {
                    width: 282px;
                    height: 154px;
                    border-radius: 8px;

                }

                .class_name {
                    font-size: 17px;
                    color: #22242E;
                    font-weight: Medium;
                    padding-top: 10px;
                    margin: 0;
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .class_class {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 13px;
                    color: #313D54;
                    line-height: 15px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    padding-top: 10px;
                    margin: 0;
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

    }
    .footer{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 60px;
        background-color: #FFFFFF;
        margin-bottom: 40px;
    }
    .noData{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img{
            width: 320px;
            height: 200px;
            margin-top: 260px;
        }
        div{
            margin-top: 20px;
        }
    }
}
</style>